<!--
  template(if) - list(show) 구조는 불필요한 로드를 방지하기 위해서임.
  refresh 는 add, edit 성공시 호출해야 함.
-->

<template>
  <div class="animated fadeIn">
    <template v-if="base">
    <List v-show="list" ref="list" />
    </template>

    <!-- <v1_detail v-if="detail" @refresh="refresh" /> -->
    <v2_detail v-if="detail" @refresh="refresh" />
  </div>
</template>

<script>
import List from './Modules.List.i18n';
import v1_detail from './Modules.v1.Detail';
import v2_detail from './Modules.v2.Detail.i18n';


export default {
  components: { List, v1_detail, v2_detail  },
  data: () => ({ base: false, list: false, detail: false }),
  methods: {
    refresh() { if(this.$refs.list) { this.$refs.list.refresh(); } },
    select({ version, id, tag }) {
      if(!id) { this.base = this.list = !(this.detail = this.edit = false); }
      else if(id === 'add') { this.edit = !(this.detail = this.list = false); }
      else { this.detail = !(this.list = this.edit = false); }

      // split version
      this.v = version
    }
  },
  created: function() { console.log('modules.vue', 'created'); },
  destroyed: function() { console.log('modules.vue', 'destroyed'); },
  mounted: function() {
    console.log('modules.vue', 'mounted');
    this.select(this.$route.params);
  },
  watch: {
    '$route' (to, from) {
      console.log('modules.vue', 'route changed', to.param);
      this.select(to.params);
    }
  },
}
</script>
